import { Card, Heading, Span } from "@icg360/design-system";

import { EmailIconLink, PhoneIconLink } from "components/common/link";
import { Stack } from "components/common/stack";
import { usePolicyDetail } from "data/ss-data-hooks";
import { formatPhone, isFormattedPhone } from "utils";

import styles from "./insurance-representative-new.module.scss";

export const InsuranceRepresentativeNew = () => {
  const { data } = usePolicyDetail();
  const {
    agencyName,
    agentStreetNumber,
    agentStreetName,
    agentZipCode,
    agentCity,
    agentState,
    agentEmail,
    agentPhone: unFormattedPhone,
  } = data?.userInsuranceRep ?? {};

  const agentPhone = isFormattedPhone(unFormattedPhone)
    ? unFormattedPhone
    : formatPhone(unFormattedPhone || "");

  return (
    <Card>
      <Stack gap="lg">
        <Stack gap="sm" className={styles.sectionPadding}>
          <Heading size="sm">Insurance representative</Heading>
          <p>
            Your insurance representative can assist with any questions or
            concerns.
          </p>
        </Stack>

        <Stack gap="sm" className={styles.sectionPadding}>
          <Heading size="xxs">{agencyName}</Heading>
          {/* agent possibly missing street address */}
          <div>
            {agentStreetNumber || agentStreetName ? (
              <>
                <Span>{`${agentStreetNumber} ${agentStreetName}`}</Span>
                <br />
              </>
            ) : null}
            <Span>{`${agentCity}, ${agentState} ${agentZipCode}`}</Span>
          </div>
        </Stack>

        <Stack gap="sm">
          <PhoneIconLink phone={agentPhone || ""} />
          <EmailIconLink email={agentEmail || ""} />
        </Stack>
      </Stack>
    </Card>
  );
};
